import Vue from 'vue';
import SocketAdapter from 'Root/plugins/socket/SocketAdapter';

export default {
  methods: {
    _initSocketAdapter() {
      if (!this.$isSSR && !Vue.prototype.$socket) {
        Vue.prototype.$socket = new SocketAdapter({
          notificationsUrl: `${window.location.hostname}/notifications`,
          chatUrl: `${window.location.hostname}/chat`,
          chatOptions: {
            autoConnect: false,
            transports: ['websocket'],
            // TODO: разобраться почему при переназначении про игрока на нового,
            //  сообщения летят в одну вкладку клиента без forceNew
            // forceNew: true,
          },
        });
      }
    },
  },
};
